import React from "react";
import Heading from "../ui/Heading";
import { Container } from "react-bootstrap";

const Insta = () => {
  return (
    <section className="insta-section section-space">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Social Media</h2>
          <p>
            Follow us on Instagram{" "}
            <a
              href="https://www.instagram.com/dcofwny/"
              className="text-dark" 
              target="_blank"
            >
              <strong>@dcofwny</strong>
            </a>
          </p>
        </Heading>
       <iframe loading="lazy" src="https://instagram.demobw.com/dcofwny/" frameborder="0" width="100%"
        class="insta-iframe"></iframe>
      </Container>
    </section>
  );
};

export default Insta;
